<template>
  <div class="view-participant-activity container-fluid"> 
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row">
          <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc padding-left-4Point4 create-element-overlay-course-title-font-styles">
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="closeOverlay($event)">
              <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
        <div class="row margin-left-2Perc">
          <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
            Activity Report of {{userObj.FirstName}} {{userObj.LastName}} 
          </div>    
        </div>
        <div class="row margin-left-2Perc vertical-align margin-Top-1Point5Perc padding-bottom-1Perc">
          <div class="col-md-1 col-lg-1">
          </div>
          <div class="col-md-1 col-lg-1 padding-left-right-0px">
            Start date
          </div>
          <div class="col-md-3 col-lg-3">
            <div class="form-group">
              <div class="col-sm-12">
                <date-picker v-model="date1" :config="config"></date-picker>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1 padding-left-right-0px">
            End date
          </div>
          <div class="col-md-3 col-lg-3">
            <div class="form-group">
              <div class="col-sm-12">
                <date-picker v-model="date2" :config="config"></date-picker>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
            <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="performOperation($event, 'view')">View</button>
          </div>
          <div class="col-md-1 col-lg-1">
            <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color padding-6px-6px" @click="performOperation($event, 'export')">Export</button>
          </div>
          <div class="col-md-1 col-lg-1">
          </div> 
        </div>
        <div class="bottom-border margin-bottom-2Perc padding-bottom-1Perc">
          <b>Current EST :</b> {{getCurrentEST()}}
        </div>
        <div class="table-responsive margin-Top-3Perc" v-if="showResultTable">
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="text-align-center font-size-15px border-right">Challenge</th>
                <th class="text-align-center font-size-15px border-right">State</th>
                <th class="text-align-center font-size-15px border-right">Activity Type</th>
                <th class="text-align-center font-size-15px border-right">IsOffline</th>
                <th class="text-align-center font-size-15px border-right">Activity Data</th>
                <th class="text-align-center font-size-15px border-right">Activity TS</th>
                <th class="text-align-center font-size-15px border-right">IP Address</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="activityObj in activityList" v-bind:key="activityObj.GroupId" >
                <td class="border-right">{{activityObj.ChallengeTitle}}</td>
                <td class="border-right">{{activityObj.UserChallengeStateTitle}}</td>
                <td class="border-right">{{activityObj.ActivityTypeTitle}}</td>
                <td class="border-right">{{activityObj.IsOffline ? 'Yes' : ''}}</td>
                <td class="border-right">{{activityObj.ActivityData}}</td>
                <td class="border-right">{{formatAndShowDate(activityObj.LoggedTS)}}</td>
                <td class="border-right">{{activityObj.IpAddress}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row margin-bottom-2Perc">
          <div class="col-md-5 col-lg-5">
          </div>  
          <div class="col-md-2 col-lg-2" v-if="showDoneBtn">
            <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="closeOverlay($event)">Done</button>
          </div>  
          <div class="col-md-5 col-lg-5">
          </div>
        </div>
        <div class="row">
        </div>         
      </div>
    </div>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
  </div> 
</template>
<script>
import Loader from '@/components/dashboard/Loader'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { participantService } from '@/server-util/participant-service'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import csvHelper from '@/utils/csv-helper'
export default {
  props: ['userObj'],
  name: 'view-participant-activity',
  created () {
    this.setDefaultValues()
  },
  data: function () {
    var startTS = moment().add(-7, 'days').format('MM/DD/YYYY')
    return {
      startDate: null,
      endDate: null,
      activityList: [],
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      showResultTable: false,
      showDoneBtn: false,
      date1: startTS,
      config: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
        maxDate: ''
      },
      date2: new Date()
    }
  },
  components: {
    'alert-box': AlertBox,
    'date-picker': datePicker,
    'loader': Loader
  },
  methods: {
    setDefaultValues: function () {
      this.config.maxDate = new Date()
    },
    closeOverlay: function (event) {
      this.$emit('closeActivity', false)
    },
    getCurrentEST: function () {
      return dmAdminUtils.getCurrentEst()
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    performOperation: function (event, selectedOperation) {
      var storeObj = this.$store
      var _this = this
      if (this.date1 === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a start date.'
        return
      }
      if (this.date2 === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an end date.'
        return
      }
      if (Date.parse(this.date1) > Date.parse(this.date2)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date must be less than the end date.'
        return
      }
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .participantActivity(
          storeObj.state.access_token,
          this.date1,
          this.date2,
          this.userObj.UserId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            console.log('Activity records: ' + JSON.stringify(responseObj.data))
            if (responseObj.data.length === 0) {
              // AK: Do not show result table to user
              this.showResultTable = false
              this.showAlertDialog = true
              this.errorMsg = 'No activity found for \'' + this.userObj.FirstName + ' ' + this.userObj.LastName + '\'.'
            } else {
              _this.activityList = responseObj.data
              switch (selectedOperation) {
                case 'view':
                  // AK: show result table to user
                  _this.showResultTable = true
                  break
                case 'export':
                  // AK: download CSV data
                  var formattedList = []
                  var columnRespKey = ['ChallengeTitle', 'UserChallengeStateTitle', 'ActivityTypeTitle', 'IsOffline', 'ActivityData', 'LoggedTS', 'IpAddress']
                  var columnAlias = ['Challenge', 'State', 'Activity Type', 'IsOffline', 'Activity Data', 'Activity TS', 'IP Address']
                  for (var i = 0; i < _this.activityList.length; i++) {
                    var obj = {
                      'ChallengeTitle': _this.activityList[i].ChallengeTitle,
                      'UserChallengeStateTitle': _this.activityList[i].UserChallengeStateTitle,
                      'ActivityTypeTitle': _this.activityList[i].ActivityTypeTitle,
                      'ActivityData': _this.activityList[i].ActivityData,
                      'IsOffline': _this.activityList[i].IsOffline ? 'Yes' : '',
                      'LoggedTS': this.formatAndShowDate(_this.activityList[i].LoggedTS),
                      'IpAddress': this.activityList[i].IpAddress
                    }
                    formattedList.push(obj)
                  }
                  var csvFileName = 'Activity_report(' + this.userObj.FirstName + ' ' + this.userObj.LastName + ')'
                  return csvHelper.export(formattedList, columnRespKey, columnAlias, csvFileName)
              }
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  computed: {
    getSelectedGroupObjValue: {
      get: function () {
        return this.selectedGroupObj
      }
    },
    getEnrolledParticipantsValue: {
      get: function () {
        return this.enrolledParticipants
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.text-align-left {
  text-align: left !important;
}
.text-align-center {
  text-align: center !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
.margin-top-3Perc {
  margin-top: 3% !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.padding-left-right-0px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.padding-6px-6px{
  padding:6px 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/ViewParticipantActivityOverlay.vue